export const horas = Array.from({ length: (18 - 8) * 2 + 1 }, (_, i) => {
  const totalMinutes = 8 * 60 + i * 30; // 8h em minutos + incremento
  const hh = String(Math.floor(totalMinutes / 60)).padStart(2, "0");
  const mm = String(totalMinutes % 60).padStart(2, "0");
  return `${hh}:${mm}`; // 08:00, 08:30, 09:00, ...
});
